export default __webpack_public_path__ + "static/media/mobile_header_logo.5be6a8f9.svg";